<button (click)="clickButton()" [disabled]="isDisabled" mat-stroked-button>
  <mat-icon>
    {{ matIcon }}
  </mat-icon>
  {{ text }}
</button>
